<div class="category-chip">
  <div [class]="classes"></div>
  <span class="body2">{{ ReleaseNoteCategoryDisplay[category()] }}</span>
</div>
